import { doesScriptExists } from 'utils/doesScriptExists';

export const injectScriptTag = (src: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (!doesScriptExists(src)) {
      const script = document.createElement('script');

      script.onload = () => resolve();
      script.onerror = reject;

      script.async = true;
      script.src = src;

      const head = document.getElementsByTagName('head')[0];

      if (head) {
        head.append(script);
      }
    } else {
      resolve();
    }
  });
};
